/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { HeaderUrls, RootState } from '../../../../ts/state';

export const isShowInstancePicker = (state: RootState): boolean =>
  state.header.showInstancePicker;

export const isShowPlanInfo = (state: RootState): boolean =>
  state.header.showPlanInfo;

export const isShowAboutModal = (state: RootState): boolean =>
  state.header.showAboutModal;

export const isShowCreateAssistantModal = (state: RootState): boolean =>
  state.header.showCreateAssistantModal;

export const listHeaderUrls = (state: RootState): HeaderUrls =>
  state.header.urls;

export const isShowRestoreIA = (state: RootState): boolean =>
  state.header.showRestoreIA;

export const selectActivePanel = (state: RootState): string | null =>
  state.header.activePanel;

export const selectCloudDashboard = (state: RootState): string | null =>
  state.header.urls.cloudDashboard;
